
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarGainProposal as ObiRadarGainProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-gain-proposal.js';
 
 
 

 
 export const ObiRadarGainProposal = createComponent({
   react: React,
   tagName: 'obi-radar-gain-proposal',
   elementClass: ObiRadarGainProposalElement,
   events: {
     
   }
  });
 
 